import { useLocation } from 'react-router-dom';

import AnalyticsPage from './pages/analytics/index';
import AnalyticsDetailPage from './pages/analytics/detail';
import DashboardPage from './pages/dashboards/show';
import MockTestNewPage from './pages/mock_tests/new';
import MockTestShowPage from './pages/mock_tests/show';
import OnDemandClassesIndexPage from './pages/on_demand_classes/index';
import ReviewAnswersPage from './pages/review/answers';
import ReviewPracticeSessionsPage from './pages/review/practice_sessions';
import ScoreReportShowPage from './pages/score_reports/show';
import ScoreReportRetryPage from './pages/score_reports/retry';

// import NotFoundPage from './pages/not_found';

const routes = [
  {
    exact: true,
    path: '/analytics/:section/:unit',
    component: AnalyticsDetailPage
  },
  {
    exact: true,
    path: '/analytics',
    component: AnalyticsPage
  },
  {
    exact: true,
    path: '/on_demand_classes',
    component: OnDemandClassesIndexPage
  },
  {
    exact: true,
    path: '/practice_tests/share/:shareableId',
    component: MockTestShowPage
  },
  {
    exact: true,
    path: '/practice_tests/start',
    component: MockTestNewPage
  },
  {
    exact: true,
    path: '/practice_tests/:id',
    component: MockTestShowPage
  },
  {
    exact: true,
    path: '/score_reports/:id',
    component: ScoreReportShowPage
  },
  {
    exact: true,
    path: '/score_reports/:id/answers/:answerId',
    component: ScoreReportShowPage
  },
  {
    exact: true,
    path: '/score_reports/:id/answers/:answerId/retry',
    component: ScoreReportRetryPage
  }
  // {
  //   path: '*',
  //   component: NotFoundPage
  // }
];

if (typeof window !== 'undefined' && window.location.host.split('.')[0] === 'toefl') {
  routes.push({
    exact: true,
    path: '/answers',
    component: ReviewAnswersPage
  });
  routes.push({
    exact: true,
    path: '/review/practice_sessions',
    component: ReviewPracticeSessionsPage
  });
  routes.push({
    exact: true,
    path: '/dashboard',
    component: DashboardPage
  });
}

export default routes;
